// extracted by mini-css-extract-plugin
export default {"colorClaro":"#fff","colorOscuro":"#262626","colorPrimario":"#122256","colorSecundario":"#ffd355"};